import React, { useEffect, useState } from "react";
import {
  Nav,
  Form,
  Card,
  Container,
  Image,
  Dropdown,
  Navbar,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../../assets/images/logo/logo.png";
//image

import { FaRegUserCircle } from "react-icons/fa";

// Import selectors & action from setting store
import * as SettingSelector from "../../../../store/setting/selectors";

// Redux Selector / Action
import { useSelector } from "react-redux";
import SearchModal from "../../../search-modal";
import { MdLogout, MdMenu, MdNotifications, MdPerson } from "react-icons/md";
import { RiProfileLine } from "react-icons/ri";

const Header = () => {
  const appName = useSelector(SettingSelector.app_name);

  const [active, setActive] = useState("home");
  const navigate = useNavigate();

  const minisidebar = () => {
    const sidebarMini = document.getElementsByTagName("ASIDE")[0];
    if (sidebarMini.classList.contains("sidebar-mini")) {
      sidebarMini.classList.remove("sidebar-mini");
    } else {
      sidebarMini.classList.add("sidebar-mini");
    }
  };

  const dropdownContent = document.querySelectorAll(".sub-drop");
  if (dropdownContent) {
    dropdownContent.forEach((element) => {
      setTimeout(() => {
        element.style = "";
      }, 100);
    });
  }

  // handleSignOut

  const handleSignOut = () => {
    // navigate("/auth/register");
    // localStorage.clear();
  };
  
  const school_code = localStorage.getItem("school_code");

  const school_code_en = school_code
    ? btoa(school_code)
    : null;
    
  const userName = localStorage.getItem("username");

  return (
    <>
      {/* <div className="position-relative"> */}
      <div className="iq-top-navbar border-bottom header-full-width">
        <Navbar
          expand="lg"
          variant="light"
          className="nav navbar navbar-expand-lg navbar-light iq-navbar p-lg-0"
          j
        >
          {/* <Navbar className="iq-navbar p-lg-0" sticky="top"> */}
          <Container
            fluid
            className="navbar-inner d-flex justify-content-between justify-content-xl-end align-items-center"
          >
            <div className="d-flex align-items-center pb-2 pb-lg-0 d-xl-none">
              <Link
                className="sidebar-toggle"
                data-toggle="sidebar"
                data-active="true"
                onClick={minisidebar}
                to="#"
              >
                <div className="icon material-symbols-outlined iq-burger-menu">
                  <MdMenu size={22} />
                </div>
              </Link>
              <div
                className="d-flex align-items-center justify-content-center d-block d-xl-none mx-3"
                style={{ width: "85px", height: "100%" }}
              >
                <img
                  src={logo}
                  alt="Logo"
                  className="img-fluid"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              </div>
            </div>

            <ul className="navbar-nav navbar-list navbar-nav navbar-list d-flex flex-row align-items-center gap-2 flex-nowrap border-top-0 me-2">
              <li className="nav-item">
                {/* <Link
                  to="/dashboard/app/notification"
                  className="search-toggle d-flex align-items-center"
                  id="notification-drop"
                >
                  <span className="material-symbols-outlined position-relative">
                    notifications
                    <span className="bg-primary text-white notification-badge"></span>
                  </span>
                </Link> */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {/* <Link
                    to="/dashboard/app/user-profile-edit"
                    className="search-toggle d-flex align-items-center position-relative"
                  >
                   
                    <MdPerson size={22} color="grey" />
                    <div className="ms-3"></div>
                  </Link> */}
                  <Link
                    to="/dashboard/app/notification"
                    className="search-toggle d-flex align-items-center position-relative"
                    id="notification-drop"
                  >
                    <MdNotifications size={24} color="grey" />

                    {/* Notification Badge */}
                    {/* <span className="bg-primary text-white notification-badge"></span> */}
                  </Link>
                </div>
              </li>
              <Dropdown as="li" className="nav-item ">
                <Dropdown.Toggle
                  as="a"
                  to="#"
                  className="d-flex align-items-center"
                  id="drop-down-arrow"
                >
                  <MdPerson size={22} color="grey" />
                  {/* <Image
                    src={user1}
                    className="img-fluid rounded-circle avatar-48 border border-2 me-3"
                    alt="user"
                    loading="lazy"
                  /> */}
                </Dropdown.Toggle>
                <Dropdown.Menu className={`sub-drop caption-menu `}>
                  <Card className="shadow-none m-0">
                    {/* <Card.Header className="pt-3 pb-2">
                      <div
                        className="header-title"
                        onClick={() =>
                          navigate("/dashboard/app/user-profile-edit")
                        }
                      >
                        <h5 className="mb-0 ">{userName}</h5>
                      </div>
                    </Card.Header> */}
                    <Card.Body className="p-0 ">
                      <Link
                        to="/dashboard/app/user-profile-edit"
                        className="d-flex align-items-center iq-sub-card pb-4 "
                        // onClick={handleSignOut}
                      >
                        {/* <span className="material-symbols-outlined">login</span> */}
                        <div
                          className="header-title"
                          onClick={() =>
                            navigate("/dashboard/app/user-profile-edit")
                          }
                        >
                          <h5 className="mb-0 ">{userName}</h5>
                        </div>
                      </Link>
                      {/* <Link
                        to="/dashboard/app/user-profile-edit"
                        className="d-flex align-items-center iq-sub-card border-0"
                      >
                    
                        <MdPerson size={22} />
                        <div className="ms-3">
                          <div className="mb-0 h6">My Profile </div>
                        </div>
                      </Link> */}
                      <Link
                        to="/dashboard/app/user-profile-edit"
                        className="d-flex align-items-center iq-sub-card border-0"
                      >
                        <div className="">
                          <div
                            to="/dashboard/app/user-profile-edit"
                            className="mb-0 h6"
                          >
                            Change Password
                          </div>
                        </div>
                      </Link>

                      <Link
                        // to={`/auth/register`}
                        to={`/auth/sign-in?school_code=${school_code_en}`}
                        className="d-flex align-items-center iq-sub-card pb-4 "
                        // onClick={handleSignOut}
                      >
                        {/* <span className="material-symbols-outlined">login</span> */}
                        <MdLogout size={22} />
                        <div className="ms-3">
                          <div className="mb-0 h6">Sign out</div>
                        </div>
                      </Link>
                    </Card.Body>
                  </Card>
                </Dropdown.Menu>
              </Dropdown>
            </ul>

            {/* <div className="d-flex align-items-center">
              <div className="d-flex align-items-center justify-content-between product-offcanvas">
                <div
                  className="offcanvas offcanvas-end shadow-none iq-product-menu-responsive d-none d-xl-block"
                  tabIndex="-1"
                  id="offcanvasBottomNav"
                ></div>
              </div>
            </div> */}
          </Container>
          {/* </Navbar> */}
        </Navbar>
      </div>

      {/* Force the header to span the full viewport width, regardless of
          any margin-left/left offset the template's stylesheet applies
          to line it up with the sidebar. Scoped to header-full-width so
          nothing else is touched.

          Also: below the xl breakpoint (where the burger menu + mobile
          logo show), pin the header to the top of the viewport so it
          stays put while the page content scrolls underneath it, instead
          of scrolling away with the rest of the page. Desktop (>=1200px)
          behavior is untouched. */}
      <style>{`
        .header-full-width {
          width: 100% !important;
          margin-left: 0 !important;
          left: 0 !important;
          right: 0 !important;
        }

        @media (max-width: 1199.98px) {
          .header-full-width {
            position: sticky !important;
            top: 0 !important;
            z-index: 1030;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
